import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UserService } from 'src/app/core/user.service';

@Component({
  selector: 'app-repetition-count-widget',
  templateUrl: './repetition-count-widget.component.html',
  styleUrls: ['./repetition-count-widget.component.scss'],
  standalone: false
})
export class RepetitionCountWidgetComponent {

  @Input() showButtonToSmartRepetition: boolean = false;
  @Output() totalCardsCountChange: EventEmitter<number> = new EventEmitter<number>();

  totalCardsCount: number | undefined;
  repeatCardsCount: number | undefined;

  constructor(
    private userService: UserService,
  ) {}

  ngOnInit() {
    this.userService.getRepeatCardsCount().subscribe((res: any) => {
      this.repeatCardsCount = res.repeatCardsCount;
      this.totalCardsCount = res.totalCardsCount;

      this.totalCardsCountChange.emit(this.totalCardsCount);
    });
  }

  goToSmartRepetition() {
    window.location.href = '/smart-repetition';
  }
}
